// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"fc341332","104":"13bc9708","598":"7766c2f7","625":"5c0c9d08","713":"c2b0d1b6"}[chunkId] + ".chunk.css";
};